import { render, staticRenderFns } from "./AutoLinkPopup.vue?vue&type=template&id=d8533ae2&scoped=true&"
import script from "./AutoLinkPopup.vue?vue&type=script&lang=js&"
export * from "./AutoLinkPopup.vue?vue&type=script&lang=js&"
import style0 from "./AutoLinkPopup.vue?vue&type=style&index=0&id=d8533ae2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8533ae2",
  null
  
)

export default component.exports